(function() {
  window.updateAllProductCountdowns = function(scope) {
    scope = scope || document;
    var countdownElements = scope.querySelectorAll(".ProductCountdownTimer");

    countdownElements.forEach(function(element) {
      var seconds = parseInt(element.dataset.productCountdown || "0", 10);

      if (element._saleCountdownInterval) {
        clearInterval(element._saleCountdownInterval);
        element._saleCountdownInterval = null;
      }

      var d = element.querySelector(".ProductDays");
      var h = element.querySelector(".ProductHours");
      var m = element.querySelector(".ProductMinutes");
      var s = element.querySelector(".ProductSeconds");
      if (!d || !h || !m || !s) return;

      var dtSaleOn = element.querySelector(".dt-sale-on");
      var endedLabel = element.querySelector(".ProductCountdownTimer__ended");
      var timeAmounts = element.querySelectorAll(".TimeAmount");

      var setVals = function(days, hrs, mins, secs) {
        d.textContent = days;
        h.textContent = hrs;
        m.textContent = mins;
        s.textContent = secs;
      };

      var setEndedUI = function(isEnded) {
        if (isEnded) {
          element.classList.add("is-ended");

          if (dtSaleOn) dtSaleOn.style.display = "none";
          if (endedLabel) endedLabel.style.display = "";

          d.style.display = "none";
          h.style.display = "none";
          m.style.display = "none";
          s.style.display = "none";
          timeAmounts.forEach(function(n) { n.style.display = "none"; });
        } else {
          element.classList.remove("is-ended");

          if (dtSaleOn) dtSaleOn.style.display = "";
          if (endedLabel) endedLabel.style.display = "none";

          d.style.display = "";
          h.style.display = "";
          m.style.display = "";
          s.style.display = "";
          timeAmounts.forEach(function(n) { n.style.display = ""; });
        }
      };

      setVals(0, 0, 0, 0);

      if (!seconds || seconds <= 0) {
        setEndedUI(true);
        return;
      }

      setEndedUI(false);

      var target = seconds * 1000;

      function tick() {
        var diff = Math.max(0, target - Date.now());

        if (diff <= 0) {
          setVals(0, 0, 0, 0);
          setEndedUI(true);

          if (element._saleCountdownInterval) {
            clearInterval(element._saleCountdownInterval);
            element._saleCountdownInterval = null;
          }
          return;
        }

        setEndedUI(false);

        var total = Math.floor(diff / 1000);
        var days = Math.floor(total / 86400); total -= days * 86400;
        var hrs = Math.floor(total / 3600); total -= hrs * 3600;
        var mins = Math.floor(total / 60);
        var secs = total - mins * 60;

        setVals(days, hrs, mins, secs);
      }

      tick();
      element._saleCountdownInterval = setInterval(tick, 1000);
    });
  };

  function runInitial() {
    if (window.updateAllProductCountdowns) window.updateAllProductCountdowns(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInitial);
  } else {
    runInitial();
  }

  document.addEventListener("variant:changed", function(event) {
    var scope = event && event.target ? event.target : document;
    if (window.updateAllProductCountdowns) window.updateAllProductCountdowns(scope);
  });

  setTimeout(runInitial, 0);
  setTimeout(runInitial, 200);
})();
